import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import ForgotPassword from "./pages/ForgotPassword";
import ContactPage from "./pages/ContactPage";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import VerifyEmail from "./pages/VerifyEmail";
import SelectRole from "./pages/SelectRole";
import BrowseListings from "./pages/BrowseListings";
import ListingDetail from "./pages/ListingDetail";
import CreateListing from "./pages/CreateListing";
import RenterDashboard from "./pages/RenterDashboard";
import LandlordDashboard from "./pages/LandlordDashboard";
import ProfilePage from "./pages/ProfilePage";
import MessagingPage from "./pages/MessagingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id during render (NOT in useEffect)
  // This prevents race conditions by processing new session_id FIRST
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  // Pages that include their own Navbar
  const pagesWithNavbar = ["/browse", "/messages", "/dashboard", "/landlord-dashboard", "/profile", "/admin", "/payment-success"];
  const needsNavbar = !pagesWithNavbar.some(p => location.pathname.startsWith(p)) &&
    location.pathname !== "/" && location.pathname !== "/select-role" &&
    !location.pathname.startsWith("/listing/") && !location.pathname.startsWith("/create-listing") &&
    !location.pathname.startsWith("/auth") && !location.pathname.startsWith("/forgot-password") &&
    !location.pathname.startsWith("/verify-email") &&
    !location.pathname.startsWith("/contact") && !location.pathname.startsWith("/terms") &&
    !location.pathname.startsWith("/privacy");

  return (
    <>
      {needsNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/select-role" element={<SelectRole />} />
        <Route path="/browse" element={<BrowseListings />} />
        <Route path="/listing/:id" element={<ListingDetail />} />
        <Route path="/create-listing" element={
          <ProtectedRoute requiredRole="landlord"><CreateListing /></ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute requiredRole="renter"><RenterDashboard /></ProtectedRoute>
        } />
        <Route path="/landlord-dashboard" element={
          <ProtectedRoute requiredRole="landlord"><LandlordDashboard /></ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute><ProfilePage /></ProtectedRoute>
        } />
        <Route path="/messages" element={
          <ProtectedRoute><MessagingPage /></ProtectedRoute>
        } />
        <Route path="/payment-success" element={
          <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>
        } />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
